import storage from 'redux-persist/es/storage'
import { persistReducer } from 'redux-persist'
import { combineReducers } from 'redux'

import loginReducer from './login.js'
import authReducer from './auth.js'
import eventsReducer from './events.js'
import locationsReducer from './locations.js'
import activationReducer from './activation.js'
import manualActivationReducer from './manualActivation.js'
import accountReducer from './account.js'
import instagramEmailReducer from './instagramEmail.js'
import resendEmailReducer from './resendEmail.js'
import attendeesReducer from './attendees.js'
import timeSlotsReducer from './timeSlots'

const rootConfig = {
  blacklist: ['routing'],
  key: 'auth',
  storage
}

const authConfig = {
  blacklist: ['routing'],
  key: 'auth',
  storage
}

const loginConfig = {
  blacklist: ['routing'],
  key: 'login',
  storage
}

const rootReducer = combineReducers({
  loginReducer: loginReducer,
  authReducer: authReducer,
  eventsReducer: eventsReducer,
  locationsReducer: locationsReducer,
  activationReducer: activationReducer,
  manualActivationReducer: manualActivationReducer,
  accountReducer: accountReducer,
  instagramEmailReducer: instagramEmailReducer,
  resendEmailReducer: resendEmailReducer,
  attendeesReducer: attendeesReducer,
  timeSlotsReducer: timeSlotsReducer
})

export default persistReducer(rootConfig, rootReducer)



// WEBPACK FOOTER //
// ./src/reducers/root.js